import { S3_URL } from 'constants';
import useTranslate from 'hooks/useTranslate';
import { useState } from 'react';
import { Col, Button } from 'react-bootstrap';
import Slider from 'react-slick';
import { getFileNameByURL } from 'utils';

interface TemplateCardProps {
	handleClick: () => void;
	data: any;
	isDownloadedSection?: any;
}

const TemplateCard: React.FC<TemplateCardProps> = ({ handleClick, data, isDownloadedSection }) => {
	const { translate } = useTranslate();
	const [currentIndex, setCurrentIndex] = useState(0);

	const handleDownloadResume = async (evt: any) => {
		evt.stopPropagation();
		if (data?.resumePath) {
			try {
				// Assuming S3_URL is a safe and trusted URL prefix
				const resumeUrl = `${S3_URL}${data.resumePath}`;

				// Simple validation to check if URL starts with S3_URL
				if (!resumeUrl.startsWith(S3_URL)) {
					throw new Error('Invalid resume URL');
				}

				const response = await fetch(resumeUrl);
				if (!response.ok) {
					throw new Error('Failed to fetch PDF file');
				}
				const blob = await response.blob();
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'resume.pdf');
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			} catch (error) {
				console.error('Error downloading PDF:', error);
				// Optionally inform the user
			}
		}
	};

	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		beforeChange: (oldIndex: number, newIndex: number) => setCurrentIndex(newIndex),
	};

	return (
		<Col sm={6} lg={isDownloadedSection ? 4 : 6} xl={isDownloadedSection ? 3 : 6}>
			<div
				className={`resume-templates-field-template text-center text-sm-start position-relative ${isDownloadedSection ? 'downloaded-section' : ''}`}
				onClick={handleClick}
			>
				{isDownloadedSection ? (
					<>
						<Button
							onClick={handleDownloadResume}
							className="remove-btn position-absolute p-0 border-0 rounded-circle"
						>
							<i className="ri-download-line w-100"></i>
						</Button>
						<div className="resume-img-box bg-white mb-3 mb-md-4">
							<img
								src={`${S3_URL}${data?.previewImage}`}
								alt="template"
								className="w-100"
								loading="lazy"
							/>
						</div>
						<h6 className={`mb-0 resume-templates-pdf-name`}>
							{getFileNameByURL(data?.resumePath)}
						</h6>
					</>
				) : (
					<>
						<Slider {...settings}>
							<div className="resume-img-box bg-white">
								<img
									src={`${S3_URL}${data?.[isDownloadedSection ? 'previewImage' : 'image']}`}
									alt="template"
									className="w-100"
									loading="lazy"
								/>
							</div>
							<div className="resume-img-box bg-white">
								<img
									src={`${S3_URL}${data?.[isDownloadedSection ? 'previewImage' : 'image']}`}
									alt="template"
									className="w-100"
									loading="lazy"
								/>
							</div>
						</Slider>
						<h3 className="resume-templates-field-template-pages">
							{translate('Template.page')} 1/{data?.previewImages?.length}
						</h3>
						<div className="text-center">
							<Button className="gray-btn rounded-pill">{translate('Template.preview')}</Button>
						</div>
					</>
				)}
			</div>
		</Col>
	);
};

export default TemplateCard;
